import React from 'react';
import { Toaster } from 'react-hot-toast';
import './App.css';
import AllRoutes from './routes';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function App() {
    return (
        <div className="App">
            <Toaster />
            <AllRoutes />
        </div>
    );
}

export default App;
